import { createSelector } from 'reselect'
import { initialState } from './reducer'

const selectWeekly = (state) => state.weekly || initialState

const makeSelectWeekly = () => createSelector(
  selectWeekly,
  (state) => state
)

export {
  selectWeekly,
  makeSelectWeekly
}
